<template>
    <m-dialog :show="show" @update:show="v => $emit('update:show', v)" heading="Email Report"><span>Fill in the fields and the report will be mailed to the specified emails...</span>
        <div class="text-gray-600">Email Address</div>
        <div class="table w-full bg-white border rounded my-1">
            <div class="table-cell align-middle">
                <input class="text-lg p-2 flex-1 outline-none bg-white w-full" v-model="email"
                       @keydown.enter="addEmail()"/>
            </div>
            <div class="table-cell w-1 align-middle">
                <div class="btn btn-primary" @click="addEmail()">Add</div>
            </div>
        </div>
        <div class="text-error-600" v-show="$v.email.$error">Email address is invalid</div>
        <span v-if="emails.length == 0">Click the button above to add emails to the list</span>
        <div class="ml-4">
            <table class="w-full">
                <tr v-for="email in emails">
                    <td>{{ email }}</td>
                    <td class="text-right"><span
                        class="cursor-pointer text-white bg-gray-600 rounded-sm leading-none px-2"
                        @click="removeEmail(email)">&times;</span></td>
                </tr>
            </table>
            <div class="text-error-600" v-show="$v.emails.$error">You need to add at least one email</div>
        </div>
        <div class="text-gray-600">Message</div>
        <m-textarea v-model="message"></m-textarea>
        <template slot="footer">
            <div class="btn btn-error" @click="$emit('update:show', false)">Cancel</div>
            <div class="btn btn-success" @click="send()">Send</div>
        </template>
    </m-dialog>
</template>

<script>
import {email, required} from 'vuelidate/lib/validators'

export default {
    props: {
        show: Boolean
    },
    data() {
        return {
            email: '',

            emails: [],
            message: ''
        }
    },
    validations: {
        email: {required, email},
        emails: {
            hasOne(val) {
                return val && val.length > 0
            }
        }
    },
    methods: {
        removeEmail(email) {
            this.emails.splice(this.emails.indexOf(email), 1)
        },
        addEmail() {
            this.$v.email.$touch()
            if (this.$v.email.$error) {
                return
            }
            this.emails.push(this.email)
            this.email = ''
            this.$v.email.$reset()
        },
        send() {
            if (this.email.length > 0) {
                this.addEmail()
            }
            this.$v.emails.$touch()
            if (this.$v.emails.$invalid) {
                return
            }
            this.$emit('send', this.emails, this.message)
            this.$emit('update:show', false)
        }
    }
}
</script>
            